import { render, staticRenderFns } from "./dialog-confirmdeletetrash.vue?vue&type=template&id=42ee35f0&"
import script from "./dialog-confirmdeletetrash.vue?vue&type=script&lang=js&"
export * from "./dialog-confirmdeletetrash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports